import React, { Component } from 'react';
import moment from 'moment';
import countdown from 'moment-countdown';

class CartTimer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            minutes: '',
            seconds: ''
        }
        this.timer = null;
    }

    startTimer = () => {
        if (moment.utc().isAfter(this.props.timer)) {
            clearInterval(this.timer);
            this.setState({
                minutes: '00',
                seconds: '00'
            }, () => {
                this.props.toggleTimerUp();
            });
        }
        else {
            const remainingTime = moment.utc().countdown(this.props.timer, countdown.MINUTES | countdown.SECONDS);
            const minutes = remainingTime.minutes.toLocaleString(undefined, { minimumIntegerDigits: 2 });
            const seconds = remainingTime.seconds.toLocaleString(undefined, { minimumIntegerDigits: 2 });
            this.setState({
                minutes,
                seconds
            });
        }
    }

    componentDidMount() {
        this.timer = setInterval(this.startTimer, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() { 
        return (
            <div className="showtix-cart__header">
                <div className="showtix-timer">
                    <div className="showtix-padder">
                        Please complete your order in <br />
                        <span className="showtix-timer-time">
                            {this.timer && !isNaN(this.state.minutes) && !isNaN(this.state.seconds) &&
                                <React.Fragment>
                                    {this.state.minutes}: {this.state.seconds}
                                </React.Fragment>
                            }
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}
 
export default CartTimer;


// WEBPACK FOOTER //
// ./src/components/Cart/CartTimer/CartTimer.js